import { useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { adminApi } from '../lib/api';
import { PageHeader, Loading, ErrorBox, Badge } from '../components/ui';

export function CustomersPage() {
  const qc = useQueryClient();
  const [q, setQ] = useState('');
  const customers = useQuery({ queryKey: ['admin-customers', q], queryFn: () => adminApi.customers(q || undefined) });
  const invalidate = () => qc.invalidateQueries({ queryKey: ['admin-customers'] });
  const block = useMutation({ mutationFn: (id: string) => adminApi.customerBlock(id), onSuccess: invalidate });
  const unblock = useMutation({ mutationFn: (id: string) => adminApi.customerUnblock(id), onSuccess: invalidate });

  if (customers.isLoading) return <Loading />;
  if (customers.error) return <ErrorBox error={customers.error} />;
  const rows = (customers.data as any)?.items ?? [];

  return (
    <div>
      <PageHeader title="Customers" subtitle="Who's ordering, what they've saved" actions={<input placeholder="Search" value={q} onChange={(e) => setQ(e.target.value)} />} />
      <div className="card">
        <table>
          <thead><tr><th>Name</th><th>Phone</th><th>Connected</th><th>Orders</th><th>Top category</th><th>Spent</th><th>Saved</th><th>Status</th><th /></tr></thead>
          <tbody>
            {rows.map((c: any) => (
              <tr key={c.id}>
                <td className="font-semibold">{c.name}</td>
                <td>{c.phone}</td>
                <td>{(c.connected ?? []).join(', ')}</td>
                <td>{c.orders}</td>
                <td>{c.topCategory}</td>
                <td>{c.spent?.formatted}</td>
                <td style={{ color: 'var(--success)' }}>{c.saved?.formatted}</td>
                <td><Badge tone={c.status === 'blocked' ? 'danger' : 'success'}>{c.status}</Badge></td>
                <td>
                  {c.status === 'blocked' ? (
                    <button className="btn-outline" onClick={() => unblock.mutate(c.id)}>Unblock</button>
                  ) : (
                    <button className="btn-outline" style={{ color: 'var(--danger)' }} onClick={() => block.mutate(c.id)}>Block</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!rows.length && <div className="text-sm py-10 text-center" style={{ color: 'var(--text-faint)' }}>No customers found</div>}
      </div>
    </div>
  );
}
